import React from 'react';
import { useTranslation } from 'react-i18next';

import TopBar from '../../atoms/TopBar/TopBar';
import { addPublicURL } from '../../Functions/AddPublicURL';
import { getIconPath } from '../../Functions/GetIconPath';
import { getAccessToken, getFromLocalStorage } from '../../Functions/LocalStorageUtils';
import { removeTokensFromLocalStorage } from '../../Functions/LocalStorageUtils';
import { useLogOutMutation } from '../../redux/api/auth';
import { setControllerType } from '../../redux/reducers/appReducer';
import { useAppDispatch, useAppSelector } from '../../redux/store';

const TopBarComponent: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  let tech = useAppSelector((state) => state.app.controllerType);
  const userName = useAppSelector((state) => state.auth.user.name);
  const [logOut] = useLogOutMutation();

  if(!tech){
    tech = getFromLocalStorage('tech');
    dispatch(setControllerType(tech || ''));
  }

  const handleLogOut = () => {
    removeTokensFromLocalStorage();
    logOut();
  }


  return (
    <TopBar underline={true}>
      <TopBar.Heading>
        <img style={{ cursor: 'pointer' }} onClick={() => window.open('https://inels.com/', '_blank')} src={getIconPath('logo')} alt="iNELS"/>
        <h1 style={{ marginLeft: '1rem', fontSize: '1.8rem' }}>{t('topbar.heading')}</h1>
      </TopBar.Heading>
      {tech !== '' && (
        <TopBar.Middle>
          <img src={addPublicURL(`/assets/inels_${tech}_logo.png`)} alt={tech} style={{ width: '6rem' }} />
        </TopBar.Middle>
      )}
      {getAccessToken() && (
        <TopBar.Right width='20vw'>
          <div style={{ display: 'flex', alignItems: 'center'}}>
            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => window.open(process.env.REACT_APP_LOGIN_URL + '/profile?returnUrl=' + encodeURIComponent(window.location.href), '_self')}>
              <img src={getIconPath('icon_user_active')} alt="User" style={{ width: '2.4rem' }} />
              <p style={{ fontSize: '1.2rem', marginLeft: '0.5rem' }}>{userName || t('topbar.guest')}</p>
            </div>
            <img onClick={handleLogOut} src={getIconPath('ico_logout')} alt="Logout" style={{ width: '2.4rem', marginLeft: '2rem', cursor: 'pointer' }} />
          </div>
        </TopBar.Right>
      )}
      {!getAccessToken() && (
        <TopBar.Right width='20vw'>
          <div style={{ display: 'flex', alignItems: 'center', width: 'fit-content', cursor: 'pointer' }}
            onClick={() => location.href = (process.env.REACT_APP_LOGIN_URL + '/?returnUrl=' + encodeURIComponent(window.location.href) || '/')}
          >
            <img src={getIconPath('icon_user_active')} alt="User" style={{ width: '2.4rem' }} />
            <p style={{ fontSize: '1.2rem', marginLeft: '0.5rem' }}>{t('topbar.guest')}</p>
          </div>
        </TopBar.Right>
      )}

        
    </TopBar>
  );
};

export default TopBarComponent;
